import Ico from './Ico'

export default Ico
